import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import foodOrdersReducer from "./foodOrderSlice";

const persistConfig = {
    key: "rood",
    storage: storage,
};

const persistedReducer = persistReducer(persistConfig, foodOrdersReducer);

const store = configureStore({
    reducer: {
        foodOrders: persistedReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST', 'persist/REGISTER', 'persist/REHYDRATE'],
            },
        }),
});

export default store;
export const persistStore1 = persistStore(store);
